import React, { Component } from "react";
import { Link } from "react-router-dom";

import Modal from "../../../component/modal/ModalTemplate";
import CheckBox from "../../../component/input/CheckBox";

class IndexNoticeModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { open, handleClose, notices = [] } = this.props;
        const { noShowToday, setValue } = this.props;

        return(
            <>
                <Modal
                    open={open}
                    handleClose={handleClose}
                    modalTitle={"공지사항"}
                    className={"react-modal"}
                >
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3">
                            <p className="mb-0">새로운 공지사항이 등록되었습니다.</p>
                            <div className="d-flex flex-column gap-3">
                                {notices.map((notice) => (
                                    <div key={notice.uid}>
                                        <p className="mb-2">
                                            제목:{" "}
                                            <Link to={`/announce/detail/${notice.uid}`} className="fw-bold text-decoration-underline">
                                                {notice.title}
                                            </Link>
                                        </p>
                                        <p className="mb-0 text-muted small">등록일: {notice.createdAt}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="mb-0">확인 경로: 고객센터 탭 &gt; 공지사항</p>
                        </div>
                        <div className={"modal-footer pt-3 d-flex justify-content-between align-items-center gap-3 flex-wrap"}>
                            <CheckBox
                                label="오늘 하루 보지 않기"
                                id="noShowToday"
                                value={noShowToday}
                                onChange={setValue}
                            />
                            <button className={"btn btn-primary btn-md"} style={{display: 'block'}} onClick={handleClose}>닫기</button>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default IndexNoticeModal;
